import supportModule from '../../support.module';

class SupportCreateCaseService {
    constructor($q, supportCaseApiService, supportConfigApiService, surveyjsConverter) {
        this.$q = $q;
        this.supportCaseApiService = supportCaseApiService;
        this.supportConfigApiService = supportConfigApiService;
        this.surveyjsConverter = surveyjsConverter;
    }

    getCaseForm() {
        var deferred = this.$q.defer();

        this.supportConfigApiService.getCaseForm().then(data => {
            deferred.resolve(this.surveyjsConverter.convert(data));
        }, deferred.reject);

        return deferred.promise;
    }

    createCase(asuiItems) {
        var body = {};

        for (var index in asuiItems) {
            var item = asuiItems[index];
            switch (item.type) {
                case 'richtext':
                    body[item.name] = item.model.text;
                    break;
                case 'file':
                    body[item.name] = item.model;
                    body[`${item.name}Name`] = item.file ? item.file.name : '';
                    break;
                default:
                    body[item.name] = item.model;
                    break;
            }
        }

        return this.supportCaseApiService.createCase(body);
    }
}

export default supportModule.service('supportCreateCaseService', SupportCreateCaseService);



// WEBPACK FOOTER //
// ./modules/support/services/supportCreateCase/supportCreateCase.service.js